export default function({ state, commit, dispatch }, query) {
    // Optimization: if all patients have been loaded, further queries are not necessary
    if (state.allPatients)
        return

    commit('startLoadingPatients')
    const loadQuery = query ? {...query, limit: 1000} : { limit: 1000}

    return dispatch('get', {
        url: '/provider/' + state.id + '/patient',
        query: loadQuery
    }, {
        root: true
    })
    .then((response) => {
        commit('addPatients', response.patient)

        // If there is a pagination token, store the token
        if (response.next) {
            dispatch('loadPatients', {
                ...loadQuery,
                next: response.next,
            })
        }
        else {
            commit('loadedAllPatients')
        }

        commit('finishLoadingPatients')
    })
    .catch((error) => {
        commit('finishLoadingPatients')
        commit('loadedAllPatients')
        throw error
    })
}
